/**
 * Created by matei on 17/11/2019
 */

import CursView from './curs-view';

export default CursView;
